var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Goodslistitem",on:{"click":_vm.itemclick}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.showimage),expression:"showimage"}]}),_c('div',{staticClass:"goods-info"},[_c('p',[_vm._v(_vm._s(_vm.goodsitem.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }